// src/api/users.js
import { apiCall } from "@/api/client";

export const getTutorialStatus = () => apiCall("/api/users/tutorial");

export const updateTutorialStatus = (payload) =>
  apiCall("/api/users/tutorial", {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const updateNativeTutorialStatus = (payload) =>
  apiCall("/api/users/tutorial/native", {
    method: "PATCH",
    body: JSON.stringify(payload),
  });

export const resetTutorialStatus = (payload) =>
  apiCall("/api/users/tutorial/reset", {
    method: "POST",
    body: JSON.stringify(payload ?? {}),
  });

export default {
  getTutorialStatus,
  updateTutorialStatus,
  updateNativeTutorialStatus,
  resetTutorialStatus,
};
